<template>
	<div class='other-data'>
		<div class='title-block'>
			<div class='control-block'>
				<div class='btn-row-block'>
					<button @click='reset' :disabled='!actLpoIsDraft'>Отмена</button>
					<button @click='save' :disabled='!actLpoIsDraft'>Сохранить</button>
				</div>
			</div>
		</div>
		<textarea :placeholder='placeholder' v-model='comment' class='text-area' :disabled='!actLpoIsDraft'></textarea>

	</div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'NotesData',
		data: () => ({
			comment: null,
			placeholder: 'Поле для примечаний, комментариев, заметок и т.п.',
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			selectedLpo() {
				return this.$store.state.selectedLpo.lpo;
			}
		},

		methods: {
			save() {
				const valueList = [
					{
						field: 'comment',
						value: this.comment
					}
				];

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo(this.selectedLpo.lpo_id);
				});
			},

			reset() {
				this.comment = this.selectedLpo.comment;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			this.reset();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	
	.title-block {
		margin-bottom: 10px;
	}

	.title {
		font-size: 1.3rem;
		font-weight: bold;
		color: #444;
	}

	.text-area {
		width: 100%;
		height: 100px;
		padding: 20px;
		border-radius: 5px;
	}

	.control-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.btn-row-block {
		float: right;
	}
	.btn-row-block > button:first-child {
		margin-right: 10px;
	}


</style>